import React, { useEffect } from "react";
import CustomTabs, { tabsProps } from "../../../../../components/Tabs";
import Contributions from "./Contributions";
import FillingDetails from "./FillingDetails/FillingDetails";
import OtherSettings from "./OtherSettings/OtherSettings";
import PayCycle from "./PayCycle";
import SalaryComponents from "./SalaryComponents/SalaryComponents";
import SalaryStructures from "./SalaryStructures/SalaryStructures";
import PayGroupSummary from "./Summary";
import TaxesAndDeductions from "./TaxesAndDeductions/TaxesAndDeductions";
import CustomRoutes from "../../../../../components/Routes/CustomRoutes";
import { useLocation, useNavigate } from "react-router-dom";
import { Space } from "antd";

const PayGroupDetails = () => {
    const navigateto = useNavigate();
    const loaction = useLocation()
    const [activeTab] = React.useState<string>(loaction.pathname);

    const Tabs: tabsProps[] = [
        { key: 'summary', label: 'Summary', content: <PayGroupSummary /> },
        { key: 'payCycle', label: 'Pay Cycle', content: <PayCycle /> },
        { key: 'contributions', label: 'Contributions', content: <Contributions /> },
        { key: 'salaryComponents', label: 'Salary Components', content: <SalaryComponents /> },
        { key: 'salaryStructures', label: 'Salary Structures', content: <SalaryStructures /> },
        { key: 'taxesDeductions', label: 'Taxes & Deductions', content: <TaxesAndDeductions /> },
        { key: 'fillingDetails', label: 'Filling Details', content: <FillingDetails /> },
        { key: 'otherSettings', label: 'Other Settings', content: <OtherSettings /> },
    ]

    useEffect(() => {
        navigateto(`${activeTab}/${Tabs[0].key}`, { replace: true });
    }, []);

    const onTabChange = (activeKey: string) => { }

    return <>
        <CustomTabs tabs={Tabs} onTabChange={onTabChange} routes={true} />
    </>
}

export default PayGroupDetails;